import React from 'react';
import { Box } from '@mui/material';

interface Props {
  color?: string;
  height?: number;
  opacity?: string;
  sx?: object;
  width?: number;
}

const Dots4x15Graphic = ({
  color = '#80aacb',
  height = 400,
  opacity = '.5',
  sx,
  width = 100,
}: Props) => (
  <Box sx={sx}>
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 89 346"
      opacity={opacity}
    >
      <circle id="Ellipse_48" cx="5.97" cy="7.08" r="4.97" fill={color} />
      <circle id="Ellipse_48-2" cx="30.82" cy="7.08" r="4.97" fill={color} />
      <circle id="Ellipse_48-3" cx="53.68" cy="7.08" r="4.97" fill={color} />
      <circle id="Ellipse_48-4" cx="77.53" cy="7.08" r="4.97" fill={color} />
      <circle id="Ellipse_48-5" cx="5.97" cy="30.93" r="4.97" fill={color} />
      <circle id="Ellipse_48-6" cx="29.82" cy="30.93" r="4.97" fill={color} />
      <circle id="Ellipse_48-7" cx="53.68" cy="30.93" r="4.97" fill={color} />
      <circle id="Ellipse_48-8" cx="77.53" cy="30.93" r="4.97" fill={color} />
      <circle id="Ellipse_48-9" cx="5.97" cy="54.79" r="4.97" fill={color} />
      <circle id="Ellipse_48-10" cx="29.82" cy="54.79" r="4.97" fill={color} />
      <circle id="Ellipse_48-11" cx="53.68" cy="54.79" r="4.97" fill={color} />
      <circle id="Ellipse_48-12" cx="77.53" cy="54.79" r="4.97" fill={color} />
      <circle id="Ellipse_48-13" cx="5.97" cy="78.64" r="4.97" fill={color} />
      <circle id="Ellipse_48-14" cx="29.82" cy="78.64" r="4.97" fill={color} />
      <circle id="Ellipse_48-15" cx="53.68" cy="78.64" r="4.97" fill={color} />
      <circle id="Ellipse_48-16" cx="77.53" cy="78.64" r="4.97" fill={color} />
      <circle id="Ellipse_48-17" cx="5.97" cy="102.49" r="4.97" fill={color} />
      <circle id="Ellipse_48-18" cx="29.82" cy="102.49" r="4.97" fill={color} />
      <circle id="Ellipse_48-19" cx="53.68" cy="102.49" r="4.97" fill={color} />
      <circle id="Ellipse_48-20" cx="77.53" cy="102.49" r="4.97" fill={color} />
      <circle id="Ellipse_48-21" cx="5.97" cy="126.35" r="4.97" fill={color} />
      <circle id="Ellipse_48-22" cx="29.82" cy="126.35" r="4.97" fill={color} />
      <circle id="Ellipse_48-23" cx="53.68" cy="126.35" r="4.97" fill={color} />
      <circle id="Ellipse_48-24" cx="77.53" cy="126.35" r="4.97" fill={color} />
      <circle id="Ellipse_48-25" cx="5.97" cy="150.2" r="4.97" fill={color} />
      <circle id="Ellipse_48-26" cx="29.82" cy="150.2" r="4.97" fill={color} />
      <circle id="Ellipse_48-27" cx="53.68" cy="150.2" r="4.97" fill={color} />
      <circle id="Ellipse_48-28" cx="77.53" cy="150.2" r="4.97" fill={color} />
      <circle id="Ellipse_48-29" cx="5.97" cy="174.05" r="4.97" fill={color} />
      <circle id="Ellipse_48-30" cx="29.82" cy="174.05" r="4.97" fill={color} />
      <circle id="Ellipse_48-31" cx="53.68" cy="174.05" r="4.97" fill={color} />
      <circle id="Ellipse_48-32" cx="77.53" cy="174.05" r="4.97" fill={color} />
      <circle id="Ellipse_48-33" cx="5.97" cy="197.91" r="4.97" fill={color} />
      <circle id="Ellipse_48-34" cx="29.82" cy="197.91" r="4.97" fill={color} />
      <circle id="Ellipse_48-35" cx="53.68" cy="197.91" r="4.97" fill={color} />
      <circle id="Ellipse_48-36" cx="77.53" cy="197.91" r="4.97" fill={color} />
      <circle id="Ellipse_48-37" cx="5.97" cy="221.76" r="4.97" fill={color} />
      <circle id="Ellipse_48-38" cx="29.82" cy="221.76" r="4.97" fill={color} />
      <circle id="Ellipse_48-39" cx="53.68" cy="221.76" r="4.97" fill={color} />
      <circle id="Ellipse_48-40" cx="77.53" cy="221.76" r="4.97" fill={color} />
      <circle id="Ellipse_48-41" cx="5.97" cy="245.62" r="4.97" fill={color} />
      <circle id="Ellipse_48-42" cx="29.82" cy="245.62" r="4.97" fill={color} />
      <circle id="Ellipse_48-43" cx="53.68" cy="245.62" r="4.97" fill={color} />
      <circle id="Ellipse_48-44" cx="77.53" cy="245.62" r="4.97" fill={color} />
      <circle id="Ellipse_48-45" cx="5.97" cy="269.47" r="4.97" fill={color} />
      <circle id="Ellipse_48-46" cx="29.82" cy="269.47" r="4.97" fill={color} />
      <circle id="Ellipse_48-47" cx="53.68" cy="269.47" r="4.97" fill={color} />
      <circle id="Ellipse_48-48" cx="77.53" cy="269.47" r="4.97" fill={color} />
      <circle id="Ellipse_48-49" cx="5.97" cy="293.32" r="4.97" fill={color} />
      <circle id="Ellipse_48-50" cx="29.82" cy="293.32" r="4.97" fill={color} />
      <circle id="Ellipse_48-51" cx="53.68" cy="293.32" r="4.97" fill={color} />
      <circle id="Ellipse_48-52" cx="77.53" cy="293.32" r="4.97" fill={color} />
      <circle id="Ellipse_48-53" cx="5.97" cy="317.18" r="4.97" fill={color} />
      <circle id="Ellipse_48-54" cx="29.82" cy="317.18" r="4.97" fill={color} />
      <circle id="Ellipse_48-55" cx="53.68" cy="317.18" r="4.97" fill={color} />
      <circle id="Ellipse_48-56" cx="77.53" cy="317.18" r="4.97" fill={color} />
      <circle id="Ellipse_48-57" cx="5.97" cy="341.03" r="4.97" fill={color} />
      <circle id="Ellipse_48-58" cx="29.82" cy="341.03" r="4.97" fill={color} />
      <circle id="Ellipse_48-59" cx="53.68" cy="341.03" r="4.97" fill={color} />
      <circle id="Ellipse_48-60" cx="77.53" cy="341.03" r="4.97" fill={color} />
    </svg>
  </Box>
);

export default Dots4x15Graphic;
